import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Is Domain Controller field definition
 * Boolean field with Yes/No dropdown for domain controller status filtering
 */
export const ADObjectIsDomainController = createBooleanSimpleFilterDefinition(
  'isdc',
  'Is Domain Controller'
);
